import React from 'react';

const LandingPage: React.FC = () => {
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <iframe
        src="https://www.strike46.games/"
        title="Help Page"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          pointerEvents: 'none',
        }}
      />
    </div>
  );
};

export default LandingPage;
